<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  (currentPage - 1) * paginationPageSize + 1
                }}
                -
                {{
                  currentPage * paginationPageSize > totalClients
                    ? totalClients
                    : currentPage * paginationPageSize
                }}
                of {{ totalClients }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="changePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div class="flex items-center sm:mr-4 mr-0 sm:order-normal order-3 sm:mt-0 mt-4">
          <vs-input
            class="sm:w-auto w-full"
            v-model="searchQuery"
            @keyup.enter="performSearch"
            placeholder="Search..."
          />
          <vs-button
            class="ml-2"
            icon="search"
            @click="performSearch"
          ></vs-button>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Archive</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Print</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :enableRtl="$vs.rtl"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>

      <vs-pagination 
        :total="totalPages" 
        :max="7" 
        :value="currentPage"
        @input="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import CellRendererLink from "../../layouts/components/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "../../layouts/components/cell-renderer/CellRendererStatus.vue";
import CellRendererClientActions from "../../layouts/components/cell-renderer/CellRendererClientActions.vue";

export default {
  components: {
    AgGridVue,
    CellRendererLink,
    CellRendererStatus,
    CellRendererClientActions,
  },
  data() {
    return {
      searchQuery: "",
      pageSize: 25,

      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "ID",
          field: "ref",
          width: 150,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Full name",
          field: "full_name",
          filter: false,
          width: 500,
          cellRendererFramework: "CellRendererLink",
        },
        {
          headerName: "Phone number",
          field: "phone_number",
          filter: false,
          width: 300,
        },
        {
          headerName: "# Products",
          valueGetter: (params) => {
            if (params.data && params.data.products && Array.isArray(params.data.products)) {
              return params.data.products.length;
            }
            return 0;
          },
          filter: false,
          width: 250,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 200,
          cellRendererFramework: "CellRendererClientActions",
        },
      ],

      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererClientActions,
      },
    };
  },
  watch: {},
  computed: {
    usersData() {
      return this.$store.getters.getClients;
    },
    paginationPageSize() {
      return this.pageSize;
    },
    totalPages() {
      const pages = this.$store.getters.getTotalClientPages;
      // Ensure it's a number and valid
      const numPages = typeof pages === 'number' ? pages : parseInt(pages) || 1;
      return numPages > 0 ? numPages : 1;
    },
    totalClients() {
      return this.$store.getters.getTotalClients;
    },
    currentPage() {
      return Number(this.$store.getters.getCurrentClientPage) || 1;
    },
  },
  methods: {
    printInvoice() {
      window.print();
    },
    async fetchClients(page = 1) {
      try {
        await this.$store.dispatch("CLIENTS_REQUEST", {
          page,
          limit: this.pageSize,
          search: this.searchQuery,
        });
      } catch (error) {
        this.$vs.notify({
          title: "Erreur",
          text: "Une erreur s'est produite lors du chargement des clients",
          color: "danger",
          position: "top-center",
        });
      }
    },
    performSearch() {
      this.fetchClients(1);
    },
    changePageSize(newSize) {
      this.pageSize = newSize;
      this.fetchClients(1);
    },
    handlePageChange(page) {
      const pageNum = Number(page);
      if (pageNum !== this.currentPage) {
        this.fetchClients(pageNum);
      }
    },
    onGridReady(params) {
      // Properly initialize grid API when grid is ready
      this.gridApi = params.api;

      // Handle RTL layout adjustment after grid is ready
      if (this.$vs.rtl) {
        this.$nextTick(() => {
          const header = this.$refs.agGridTable.$el.querySelector(
            ".ag-header-container"
          );
          if (header) {
            header.style.left =
              "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
          }
        });
      }
    },
  },
  beforeDestroy() {
    // Clean up AG Grid instance to prevent memory leaks
    if (this.gridApi) {
      // Clear any event listeners if needed
      // AG Grid Vue automatically destroys the grid when component is destroyed
      // but we clear the reference to prevent further usage
      this.gridApi = null;
    }
    // Clear gridOptions reference
    if (this.gridOptions) {
      this.gridOptions.api = null;
    }
  },
  async beforeMount() {
    await this.fetchClients(1);
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
